import Styles from './index.scss';
import StyleVars from '../_variables.module.scss';

export { StyleVars };
export default Styles;
